import React from 'react';
import ScrollMenu from 'react-horizontal-scrolling-menu';
import '../scss/_scrollMenu.scss';

const MenuItem = ({ text, selected }) => {
    return <div className={`menu-item ${selected ? 'active' : ''}`}>{text}</div>;
};

// All items component
// Important! add unique key
export const Menu = (list, selected) =>
    list.map(el => {
        const { name, title } = el;
        return <MenuItem text={name} key={title} selected={selected} />;
    });


const Arrow = ({ text, className }) => {
    return (
        <div className={className}>{text}</div>
    );
};

const ArrowLeft = Arrow({ text: '<', className: 'arrow-prev' });
const ArrowRight = Arrow({ text: '>', className: 'arrow-next' });

const MyScrollMenu = (props) => {
    return <div className="scroll-menu-container" id="scroll-menu">
        <ScrollMenu 
            alignCenter={props.alignCenter}
            hideArrows={true}
            hideSingleArrow={true}
            itemsCount={props.data.length}
            arrowLeft={ArrowLeft}
            arrowRight={ArrowRight}  
            data={Menu(props.data, props.selected)}
            onSelect={props.onSelect}
        />
    </div>
}

export default MyScrollMenu;